import commissionsLocales from '@/locales/es/humanResources/commissions.locales';
import employeesLocales from '@/locales/es/humanResources/employee.locales';
import payrollLocales from '@/locales/es/humanResources/payroll.locales';

export default {
    ...employeesLocales,
    ...commissionsLocales,
    ...payrollLocales,
};
